const initialChannelsState = {
  channels: [],
  totalChannels: 0,
  totalPages: 0,
  loading: false,
  error: null,
};

export const channelsReducer = (state = initialChannelsState, action) => {
  switch (action.type) {
    case 'FETCH_CHANNELS_REQUEST':
      return {
        ...state,
        loading: true,
        error: null,
      };
    case 'FETCH_CHANNELS_SUCCESS':
      return {
        ...state,
        channels: action.payload.channels,
        totalChannels: action.payload.totalChannels,
        totalPages: action.payload.totalPages,
        loading: false,
        error: null,
      };
    case 'FETCH_CHANNELS_FAILED':
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};
